/**
 * PolicyService
 * Service for Policy entity operations
 * Route: api/policies
 */
import { CrudService } from '../base/CrudService';
/**
 * PolicyService
 * Handles policy CRUD operations and policy-specific queries
 */
export class PolicyService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PolicyService.DEFAULT_SERVICE_PATH,
            basePath: PolicyService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== MODELVIEW ENDPOINTS ====================
    /**
     * Get policy ModelView by ID
     * GET api/policies/view/{id}
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Policy ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get policy ModelView by ID with full response
     */
    getViewRaw(id) {
        const endpoint = this.getEndpoint('view-by-id', `view/${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    /**
     * Get all policy ModelViews with pagination
     * GET api/policies/view?page={page}&pageSize={pageSize}
     */
    async getAllViews(page = 1, pageSize = 50) {
        const response = await this.getAllViewsRaw(page, pageSize);
        if (!response.data) {
            throw new Error('Failed to retrieve policy ModelViews');
        }
        return response.data;
    }
    /**
     * Get all policy ModelViews with full response
     */
    getAllViewsRaw(page = 1, pageSize = 50) {
        const endpoint = this.getEndpoint('view-all', 'view');
        const url = this.buildUrlWithParams(endpoint, { page, pageSize });
        return this.http.get(url);
    }
    /**
     * Get policy ModelViews by category
     * GET api/policies/view/by-category/{categoryId}
     */
    async getViewsByCategory(categoryId) {
        const response = await this.getViewsByCategoryRaw(categoryId);
        return response.data ?? [];
    }
    /**
     * Get policy ModelViews by category with full response
     */
    getViewsByCategoryRaw(categoryId) {
        const endpoint = this.getEndpoint('view-by-category', `view/by-category/${categoryId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
PolicyService.DEFAULT_SERVICE_PATH = 'hr';
PolicyService.BASE_PATH = 'api/policies';
//# sourceMappingURL=PolicyService.js.map